import React, { ReactNode } from "react";
import { Wrapper } from "../Grid";
import styles from "./SpacedSection.module.scss";

const SpacedSection = ({ children }: { children: ReactNode }) => (
  <Wrapper className={styles.root}>
    <section className={styles.section}>{children}</section>
  </Wrapper>
);

export default SpacedSection;
